// extracted by mini-css-extract-plugin
export default {"Root":"ImageUploadArea_Root__x1Mtc","Dropzone":"ImageUploadArea_Dropzone__RlXzu"};